import script from "./Provider-search.vue?vue&type=script&setup=true&lang=js"
export * from "./Provider-search.vue?vue&type=script&setup=true&lang=js"

import "./Provider-search.vue?vue&type=style&index=0&id=17cf10a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cf10a0"]])

export default __exports__